// Группа переключателей секций в виде схемы.

import {Component, h} from 'preact';
import FilterCheckboxesItem from './FilterCheckboxesItem';
import sectionScheme from './sectionSchemeSvgPaths.json';
import {StateFilterCheckbox} from './Store/State';

/**
 * Component Properties.
 */
interface FilterSectionsProps
{
	/** Имя формы */
	formName: string;
	/** Имя переключателя */
	baseName: string;
	/** Подпись группы */
	label: string;
	/** Переключатели */
	items: StateFilterCheckbox[];
}

/**
 * Component State
 */
interface FilterSectionsState
{
	[key: string]: void;
}

/**
 * Группа переключателей секций в виде схемы.
 */
class FilterSections extends Component<FilterSectionsProps, FilterSectionsState>
{
	/**
	 * Элемент списка чекбоксов для поиска чекбоксе, соответствующего объекту
	 * на схеме.
	 */
	private checkboxesList: HTMLElement;
	
	/**
	 * Сформировать объект на схеме.
	 * 
	 * @param item Информация о пункте списка.
	 * @param index Номер пункта в перечне (от 0).
	 */
	private static createObject( item: StateFilterCheckbox, index: number ): JSX.Element[] | ''
	{
		const sectionObjectPaths: string[] = sectionScheme.paths;
		const sectionLabelTransforms: string[] = sectionScheme.labels;
		
		return (
			sectionObjectPaths[index]
			? [
				(<path
					d={sectionObjectPaths[index]}
					class={
						( item.checked ? 'checked' : '' )
						+ ( item.disabled ? ' disabled' : '' )
					}
					data-index={index}
				/>),
				(<text transform={sectionLabelTransforms[index] || ''}>
					{item.label}
				</text>),
			]
			: ''
		);
	}
	
	/**
	 * Render component.
	 */
	public render( {formName, baseName, label, items}: FilterSectionsProps ): JSX.Element
	{
		return (
			<li class={'sections field-' + baseName}>
				<fieldset>
					<legend>{label}</legend>
					<div class="scheme">
						<svg width="289" height="95" viewBox="0 0 289 95">
							<g class="objects" onClick={this.onObjectClick}>
								{items.map( FilterSections.createObject )}
							</g>
						</svg>
					</div>
					<ul ref={this.refCheckboxesList}>
						{
							items.map(
								( item: StateFilterCheckbox ) => (
									<FilterCheckboxesItem
										formName={formName}
										name={baseName + '[]'}
										{...item}
									/>
								),
							)
						}
					</ul>
				</fieldset>
			</li>
		);
	}
	
	/**
	 * Сохранение ссылки на элемент списка чекбоксов.
	 */
	private refCheckboxesList = ( element: HTMLElement ): void =>
	{
		this.checkboxesList = element;
	}
	
	/**
	 * Начатие на объекты схемы.
	 */
	private onObjectClick = ( event: Event ): void =>
	{
		const target = event.target as Element;
		const index = Number( target.getAttribute( 'data-index' ) );
		const listItem = this.checkboxesList.children.item( index );
		
		if ( !listItem )
		{
			return;
		}
		
		const checkbox = listItem.querySelector( 'input' );
		
		if ( checkbox )
		{
			checkbox.click();
		}
	}
	
}

/**
 * Module.
 */
export {
	FilterSections as default,
	FilterSectionsProps,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/FilterSections.tsx